<template>
  <section class="cta-section">
    <div class="cta-section__top">
      <h2 class="cta-section__top__title">{{ title }}</h2>
      <div class="cta-section__top__pdf-title">
        {{ pdfTitle }}
      </div>
    </div>

    <img
      :src="`${$baseUrl}images/pdf-image-${i18n.locale.value}.webp`"
      alt=""
      class="cta-section__image"
    />

    <div class="cta-section__bottom">
      <div class="cta-section__bottom__buttons">
        <ButtonPrimary
          class="cta-section__bottom__download-report"
          :label="$t('general.ctas.downloadReport')"
          :url="pdfLink"
          :isBlack="!!route.query.caseStudy"
          :component-title="pdfTitle"
          component-type="cta section"
          :iconAfter="download"
        />
        <ButtonPrimary
          v-if="!!extractLink"
          class="cta-section__bottom__download-report"
          :label="$t('general.ctas.downloadExtract')"
          :url="`${$baseUrl}${extractLink}`"
          :isBlack="!!route.query.caseStudy"
          :iconAfter="download"
          :component-title="pdfTitle"
          component-type="cta section"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { inject } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { download } from "@/assets/icons/icons.js";

import ButtonPrimary from "../atoms/ButtonPrimary.vue";
import ButtonGhost from "../atoms/ButtonGhost.vue";

defineProps({
  title: String,
  pdfTitle: String,
  currentPage: String,
  pdfLink: String,
  extractLink: String,
  pdfSize: String,
});

const $baseUrl = inject("$baseUrl");
const i18n = useI18n();
const route = useRoute();
</script>

<style lang="scss" scoped>
.cta-section {
  --section-padding-v-t: 14vh;
  --section-padding-v-b: calc(var(--section-padding-v-t) * 0.5);

  border-top: var(--section-border);

  .case-study & {
    background-color: var(--background-base);
    color: var(--color-white);
  }

  .mobile &,
  .tablet & {
    --section-padding-v-t: 7vh;
  }

  position: relative;

  &__top {
    padding: var(--section-padding-v-t) 7vw var(--section-padding-v-b)
      calc(var(--page-padding-h) + var(--page-padding-h-offset));

    .large &,
    .desktop & {
      width: 50%;
    }

    .mobile &,
    .tablet & {
      text-align: center;
    }

    &__title {
      .large &,
      .desktop & {
        @include header-h-1;

        margin-bottom: 1.65rem;
      }

      .mobile &,
      .tablet & {
        @include header-h-3;

        margin-bottom: toRem(10);
      }
    }

    &__pdf-title {
      .large &,
      .desktop & {
        @include title-m;

        margin-bottom: 1rem;
      }

      .mobile &,
      .tablet & {
        @include title-s;

        margin-bottom: toRem(10);
      }
    }

    &__pdf-size {
      .mobile &,
      .tablet & {
        @include p-s;
      }
    }
  }

  &__bottom {
    background-color: var(--background-weaker-inverted);
    padding: var(--section-padding-v-b) var(--page-padding-h)
      var(--section-padding-v-t)
      calc(var(--page-padding-h) + var(--page-padding-h-offset));
    display: flex;
    flex-direction: column;
    width: 100%;

    &__buttons {
      width: fit-content;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .case-study & {
      background-color: var(--background-weaker-inverted-light);
      color: var(--color-black);
    }

    .mobile &,
    .tablet & {
      margin-top: -2.5rem;
      padding: calc(var(--section-padding-v-b) + 2.5rem) var(--page-padding-h)
        var(--section-padding-v-t);
    }

    > * {
      .mobile &,
      .tablet & {
        margin: 0 auto;
      }

      &:not(:last-child) {
        margin-bottom: 1.25rem;
      }
    }

    &__download-report {
      // padding: 0 !important;
      width: 100%;
    }
  }

  &__image {
    .desktop &,
    .large & {
      position: absolute;
      top: calc(var(--section-padding-v-t) * 0.75);
      right: var(--page-padding-h);
      height: calc(100% - var(--section-padding-v-t) * 1.5);
    }

    .mobile &,
    .tablet & {
      width: 80%;
      max-width: toRem(255);
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
